const topics = [
  { name: '#顶流恋情实锤', heat: '98.6万', color: 'primary' },
  { name: '#综艺翻车名场面', heat: '87.3万', color: 'accent' },
  { name: '#红毯谁更胜一筹', heat: '76.2万', color: 'primary' },
  { name: '#合约纠纷内幕', heat: '68.9万', color: 'accent' },
  { name: '#影视剧透慎入', heat: '62.1万', color: 'primary' },
  { name: '#演唱会突发意外', heat: '55.4万', color: 'accent' },
  { name: '#艺人深夜发文', heat: '48.7万', color: 'primary' },
  { name: '#跨界代言大瓜', heat: '42.3万', color: 'accent' },
  { name: '#私生活大起底', heat: '38.9万', color: 'primary' },
  { name: '#娱乐圈潜规则', heat: '35.1万', color: 'accent' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="bg-background-100 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-semibold mb-4">
              热门话题
            </span>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
              话题热度榜
            </h2>
            <p className="text-foreground-600 text-sm max-w-lg mx-auto">
              当前最受关注的娱乐八卦话题，点击加入讨论
            </p>
          </div>

          <div className="flex flex-wrap justify-center gap-3 md:gap-4">
            {topics.map((topic, i) => (
              <a
                key={topic.name}
                href="#cards"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className={`group flex items-center gap-3 px-5 py-3 rounded-full border transition-all duration-200 cursor-pointer ${
                  topic.color === 'primary'
                    ? 'border-primary-200 bg-primary-50/50 hover:bg-primary-100 hover:border-primary-300'
                    : 'border-accent-200 bg-accent-50/50 hover:bg-accent-100 hover:border-accent-300'
                }`}
              >
                <span
                  className={`w-6 h-6 flex items-center justify-center rounded-full text-xs font-bold ${
                    i < 3
                      ? 'bg-primary-500 text-white'
                      : 'bg-background-200 text-foreground-500'
                  }`}
                >
                  {i + 1}
                </span>
                <span
                  className={`text-sm font-medium ${
                    topic.color === 'primary'
                      ? 'text-primary-800 group-hover:text-primary-900'
                      : 'text-accent-800 group-hover:text-accent-900'
                  }`}
                >
                  {topic.name}
                </span>
                <span className="text-xs text-foreground-400 flex items-center gap-1">
                  <i className="ri-fire-line text-xs"></i>
                  {topic.heat}
                </span>
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}